import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeSignReceiptCommand } from './serialize';

/** POST `…/{id}/cancel`：DRAFT／ESTABLISHED → CANCELLED。 */
export async function cancelSignReceipt(id, payload) {
  const { data: raw } = await request.post(
    `/aftersales/sign-receipt/${id}/cancel`,
    serializeSignReceiptCommand(payload),
  );
  return parseVer4DetailResponse(raw);
}
